import Vue from 'vue';

export default () => {
  Vue.config.productionTip = false;
};
